export const ALLOWED_FILE_EXT = ['png', 'svg', 'jpeg', 'jpg', 'gif']
